import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Users,
  Shield,
  User,
  Building
} from 'lucide-react';

const CompanyStatsCards = ({ stats }) => {
  const { t } = useTranslation();
  const { totalCount, adminCount, candidateCount, employeeCount } = stats;

  const statCards = [
    {
      title: t('companyAdmins.totalUsers'),
      value: totalCount,
      icon: Users,
      color: 'blue',
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-600',
      iconColor: 'text-blue-600'
    },
    {
      title: t('companyAdmins.admins'),
      value: adminCount,
      icon: Shield,
      color: 'red',
      bgColor: 'bg-red-100',
      textColor: 'text-red-600',
      iconColor: 'text-red-600'
    },
    {
      title: t('companyAdmins.candidates'),
      value: candidateCount,
      icon: User,
      color: 'blue',
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-600',
      iconColor: 'text-blue-600'
    },
    {
      title: t('companyAdmins.employees'),
      value: employeeCount,
      icon: Building,
      color: 'green',
      bgColor: 'bg-green-100',
      textColor: 'text-green-600',
      iconColor: 'text-green-600'
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        return (
          <div
            key={index}
            className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 hover:shadow-md transition-shadow"
          >
            <div className="flex items-center">
              <div className={`p-2 rounded-lg ${stat.bgColor}`}>
                <Icon className={`h-5 w-5 ${stat.iconColor}`} />
              </div>
              <div className="ml-3">
                <p className=" text-gray-600">{stat.title}</p>
                <p className={`font-bold ${stat.textColor}`}>{stat.value}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CompanyStatsCards;